module.exports = __webpack_public_path__ + "static/media/Sportsmate_about@2x.b8fe7f23.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sportsmate/Sportsmate_about@2x.png
// module id = 134
// module chunks = 0